import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c(VChip,_vm._b({attrs:{"color":_vm.color ? _vm.color : _vm.value.style.color || 'primary',"dark":_vm.value.style.dark ? true : false}},'v-chip',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.shortName ? _vm.value.shortName : _vm.value.text)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }